/**
 * Active company id while viewing a record from another company (pending-invoices popup).
 * Kept separate from MultiCompanyViewTokenService to avoid circular DI with WebServiceService.
 */
export class MultiCompanyViewContext {
  private static activeViewCompanyId: string | null = null;

  static getActiveViewCompanyId(): string | null {
    return MultiCompanyViewContext.activeViewCompanyId;
  }

  static setActiveViewCompanyId(companyId: string | null): void {
    MultiCompanyViewContext.activeViewCompanyId =
      companyId != undefined && companyId != null && companyId !== ''
        ? companyId.toString()
        : null;
  }

  static clearActiveViewCompanyId(): void {
    MultiCompanyViewContext.activeViewCompanyId = null;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2607514992/src/src/app/shared/services/multi-company-view-context.ts